"use client";

import { useState } from "react";
import Image from "next/image";
import { initials } from "@/lib/utils";

/**
 * Fills its (relative, overflow-hidden) parent with a photo, or - when there is no photo or it fails to
 * load - a brand gradient with the person's initials, so there is never a broken-image icon.
 */
export function PhotoFallback({ src, name, sizes = "80px", textClassName = "text-xl", fit = "cover" }: { src?: string | null; name: string; sizes?: string; textClassName?: string; fit?: "cover" | "contain" }) {
  const [failed, setFailed] = useState(false);
  if (src && !failed) {
    return <Image src={src} alt={name} fill sizes={sizes} unoptimized={/^https?:\/\/(localhost|127\.0\.0\.1)/.test(src)} className={fit === "contain" ? "object-contain" : "object-cover"} onError={() => setFailed(true)} />;
  }
  return (
    <span
      aria-label={name}
      className={`absolute inset-0 flex items-center justify-center bg-gradient-to-br from-brand-700 via-brand-600 to-brand-900 font-display font-semibold text-white ${textClassName}`}
    >
      <span className="absolute inset-0 bg-[radial-gradient(120%_80%_at_20%_0%,rgba(255,255,255,0.28),transparent_60%)]" />
      <span className="relative">{initials(name)}</span>
    </span>
  );
}
